<template lang="html">
  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth auth-bg-1 theme-one">
          <div class="row w-100">
            <div class="col-lg-4 mx-auto">
              <div class="auto-form-wrapper">
                <div v-if="error" class="alert alert-danger">{{error}}</div>
                  <div class="form-group">
                    <label class="label">Email</label>
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Email" v-model="email" id="email">
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="mdi mdi-check-circle-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="label">Wachtwoord</label>
                    <div class="input-group">
                      <input type="password" class="form-control" placeholder="Wachtwoord" v-model="password" id="password">
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="mdi mdi-check-circle-outline"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <butcton class="btn btn-primary submit-btn btn-block" @click="login()">Login</butcton>
                  </div>
              </div>
              <div style="color: white; font-size: x-small">Versie: 0.11</div>

            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>

</template>

<script lang="js">
import store from '../../../store'
import axios from 'axios'
let server = require('../../../server')

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  mounted () {
  },
  methods: {
    routerPush () {

    },
    async login () {
      console.log('Attempting to login...')
      let self = this
      await this.$firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(async user => {
          console.log('Successful login! ✅')
          console.log(user)
          try {
            let postData = {
              user: user
            }
            await axios({
              method: 'post',
              url: server.SERVER_URL + '/get_user_from_firebase',
              data: postData
            })
              .then(async function (response) {
                console.log('user = ')
                console.log(response)
                // self.users_db = response.data
                let storeData = {
                  role: response.data.role,
                  office: response.data.office,
                  officeString: response.data.officeString,
                  email: response.data.email,
                  firstname: response.data.firstname,
                  is_online: response.data.is_online
                }
                await store.commit('SET_ROLE_OFFICE', storeData)
                console.log('role = ' + response.data.role.toString())
                console.log('office = ' + response.data.office.toString())
                console.log('officeString = ' + response.data.officeString.toString())
                console.log('email = ' + response.data.email.toString())
                console.log('first name = ' + response.data.firstname.toString())
                console.log('is_online = ' + response.data.is_online.toString())
                let user = {
                  displayName: response.data.email,
                  email: response.data.email
                }

                await store.dispatch('fetchUser', user)
                console.log('router.push/')
                self.$router.push('/')
              })
          } catch (e) {
            console.error('Error while trying to get users!')
            console.error(e)
          }
        }).catch(err => {
          this.error = err.message
          console.log('LOGIN FAILED ❌')
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/samples/user-pages/login.vue